import { MangoQuerySortDirection, MangoQuerySortPart } from 'rxdb';
import { RecordTypeEnum } from '../../models';
import { WorkspaceDatabaseKeys } from '../../schemas';

export class SortQueryBuilder {
	private sortQuery: MangoQuerySortPart = {};

	public constructor() {}

	public addColumnAndDirection(columnName: string, sortDirection: MangoQuerySortDirection): void {
		this.sortQuery[columnName] = sortDirection;
	}

	public addColumnAndDirectionByRecordType(
		columnName: string,
		sortDirection: MangoQuerySortDirection,
		recordType: RecordTypeEnum
	): void {
		switch (recordType) {
			case RecordTypeEnum.depthFromToRecordType:
				this.sortQuery[columnName] = sortDirection;
				break;
			default:
				this.sortQuery[WorkspaceDatabaseKeys.internalColumns.rxdbid] = sortDirection;
		}
	}

	public build(): MangoQuerySortPart<any> {
		return this.sortQuery;
	}
}
